import { fetchCachedPublicGet } from "./publicRequest";

export const fetchDestinationBySlug = (slug, options = {}) => {
  if (!slug) {
    return Promise.reject(new Error("Destination slug missing"));
  }
  const query = new URLSearchParams();
  if (options.view) query.set("view", options.view);
  const suffix = query.toString();
  const requestOptions = { ...options };
  delete requestOptions.view;
  const path = `/destinations/${slug}${suffix ? `?${suffix}` : ""}`;
  return fetchCachedPublicGet(path, requestOptions);
};

export const fetchDestinationsList = (params = {}, options = {}) => {
  const query = new URLSearchParams(params).toString();
  const path = query ? `/destinations?${query}` : "/destinations";
  return fetchCachedPublicGet(path, options);
};

export const fetchDestinationFeed = (params = {}, options = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  const path = query ? `/destinations/feed?${query}` : "/destinations/feed";
  return fetchCachedPublicGet(path, options);
};

export const fetchDestinationComposition = (slug, params = {}, options = {}) => {
  if (!slug) return Promise.reject(new Error("Destination slug missing"));
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  return fetchCachedPublicGet(`/destinations/${slug}/composition${query ? `?${query}` : ""}`, options);
};

export const fetchDestinationBanner = (params = {}, options = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  const path = query ? `/destinations/banner?${query}` : "/destinations/banner";
  return fetchCachedPublicGet(path, options);
};

export const fetchHomepageFeatured = (params = {}, options = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  const path = query ? `/homepage/featured?${query}` : "/homepage/featured";
  return fetchCachedPublicGet(path, options);
};

export const fetchTopDestinations = (options = {}) =>
  fetchCachedPublicGet("/website/top-destinations", options);

export const fetchHomepageExperiences = (params = {}, options = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  const path = query ? `/homepage/experiences?${query}` : "/homepage/experiences";
  return fetchCachedPublicGet(path, options);
};
